import { PlugZap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { F } from "@/components/ajustes/Field";

export const CorreoTab = ({ s, sec, busy, test }) => (
  <>
    <F label="Servidor IMAP" hint="Ej.: mail.paginauno.do (BlueHost) o imap.gmail.com">
      <Input value={s.email?.imap_host || ""} onChange={(e) => sec("email", "imap_host", e.target.value)} data-testid="imap-host-input" />
    </F>
    <F label="Puerto"><Input value={s.email?.imap_port || 993} onChange={(e) => sec("email", "imap_port", Number(e.target.value))} data-testid="imap-port-input" /></F>
    <F label="Usuario"><Input value={s.email?.username || ""} onChange={(e) => sec("email", "username", e.target.value)} data-testid="imap-user-input" /></F>
    <F label="Contraseña"><Input type="password" value={s.email?.password || ""} onChange={(e) => sec("email", "password", e.target.value)} data-testid="imap-password-input" /></F>
    <F label="Carpeta"><Input value={s.email?.folder || "INBOX"} onChange={(e) => sec("email", "folder", e.target.value)} data-testid="imap-folder-input" /></F>
    <div className="flex items-center gap-3 mb-4">
      <Switch checked={!!s.email?.only_unread} onCheckedChange={(v) => sec("email", "only_unread", v)} data-testid="only-unread-switch" />
      <span className="text-sm">Leer solo mensajes no leídos</span>
    </div>
    <Button variant="outline" onClick={() => test("email")} disabled={busy === "email"} data-testid="test-email-btn">
      <PlugZap className="h-4 w-4 mr-2" />Probar conexión
    </Button>
  </>
);

export const SmtpTab = ({ s, sec, busy, test }) => (
  <>
    <F label="Servidor SMTP"><Input value={s.smtp?.host || ""} onChange={(e) => sec("smtp", "host", e.target.value)} data-testid="smtp-host-input" /></F>
    <F label="Puerto" hint="587 con STARTTLS o 465 con SSL"><Input value={s.smtp?.port || 587} onChange={(e) => sec("smtp", "port", Number(e.target.value))} data-testid="smtp-port-input" /></F>
    <F label="Usuario"><Input value={s.smtp?.username || ""} onChange={(e) => sec("smtp", "username", e.target.value)} data-testid="smtp-user-input" /></F>
    <F label="Contraseña"><Input type="password" value={s.smtp?.password || ""} onChange={(e) => sec("smtp", "password", e.target.value)} data-testid="smtp-password-input" /></F>
    <F label="Remitente"><Input value={s.smtp?.from_email || ""} onChange={(e) => sec("smtp", "from_email", e.target.value)} data-testid="smtp-from-input" /></F>
    <F label="Nombre del remitente"><Input value={s.smtp?.from_name || ""} onChange={(e) => sec("smtp", "from_name", e.target.value)} data-testid="smtp-fromname-input" /></F>
    <Button variant="outline" onClick={() => test("smtp")} disabled={busy === "smtp"} data-testid="test-smtp-btn">
      <PlugZap className="h-4 w-4 mr-2" />Enviar correo de prueba
    </Button>
  </>
);

export const TelegramTab = ({ s, sec, busy, test }) => (
  <>
    <F label="Bot token" hint="Cree el bot con @BotFather y añádalo como administrador del canal.">
      <Input type="password" value={s.telegram?.bot_token || ""} onChange={(e) => sec("telegram", "bot_token", e.target.value)} data-testid="tg-token-input" />
    </F>
    <F label="Chat / canal" hint="Ej.: @paginauno_do o el ID numérico del grupo.">
      <Input value={s.telegram?.chat_id || ""} onChange={(e) => sec("telegram", "chat_id", e.target.value)} data-testid="tg-chat-input" />
    </F>
    <Button variant="outline" onClick={() => test("telegram")} disabled={busy === "telegram"} data-testid="test-telegram-btn">
      <PlugZap className="h-4 w-4 mr-2" />Enviar mensaje de prueba
    </Button>
  </>
);

export const MarcaTab = ({ s, sec }) => (
  <>
    <F label="Razón social" hint="Aparece en el pie de todos los boletines.">
      <Input value={s.branding?.agency_name || ""} onChange={(e) => sec("branding", "agency_name", e.target.value)} data-testid="agency-name-input" />
    </F>
    <F label="Sitio de la agencia" hint="Para anuncios y servicios de información.">
      <Input value={s.branding?.agency_url || ""} onChange={(e) => sec("branding", "agency_url", e.target.value)} data-testid="agency-url-input" />
    </F>
    <F label="Logo de la agencia (URL)">
      <Input value={s.branding?.agency_logo_url || ""} onChange={(e) => sec("branding", "agency_logo_url", e.target.value)} data-testid="agency-logo-input" />
    </F>
    {s.branding?.agency_logo_url && (
      <img src={s.branding.agency_logo_url} alt="" className="h-12 mt-2 object-contain" />
    )}
  </>
);
